import type React from "react"
import { NavLink } from "react-router-dom"
import {
  Box,
  PlusCircle,
  DashCircle,
  FileText,
  ArrowLeftRight,
  LayoutSidebar,
  LayoutSidebarInset,
  Collection,
  House,
  Gear,
  // BarChart
} from "react-bootstrap-icons"
import "../../styles/Sidebar.css"
import { connect } from "react-redux"
import type { RootState } from "../../store"
import { Truck } from "lucide-react"
import Preferencias from "../Configuracion/Preferencias"
import { useState } from "react"

const classNames = (...classes: (string | boolean | undefined)[]): string => {
  return classes.filter(Boolean).join(" ")
}

export interface NavItem {
  name: string
  href?: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  isSubmenu?: boolean
}

interface GeneralProps {
  isCollapsed?: boolean
  isDarkMode: boolean
  activo?: string
  onToggleCollapse?: () => void
}

const Sidebar: React.FC<GeneralProps> = ({
  isCollapsed = false,
  isDarkMode,
  activo = "General",
  onToggleCollapse,
}) => {
  const [mostrarModal, setMostrarModal] = useState(false)

  const navigation: NavItem[] = [
    // { name: "Dashboard", href: "/DashBoard", icon: BarChart },
    { name: "Inventario", href: "/Inventario", icon: Box },
    { name: "Altas", href: "/Altas", icon: PlusCircle },
    { name: "Traslados", href: "/Traslados", icon: ArrowLeftRight },
    { name: "Traspasos", href: "/Traspasos", icon: Truck },
    { name: "Bajas", href: "/Bajas", icon: DashCircle },
    { name: "Informes", href: "/Informes", icon: FileText },
    { name: "Mantenedores", href: "/Mantenedores", icon: Collection },
  ]

  return (
    <>
      <div className={`sidebar-container sticky-top d-flex flex-column ${isCollapsed ? "sidebar-collapsed" : "sidebar-expanded"}`}
      >
        {/* Header */}
        <div className="text-center text-white flex-shrink-0">
          <div className="d-flex mx-2 top-0 w-75">
            <div className="text-bg-primary p-1 w-50"></div>
            {/* <StarFill
              width={8}
              height={8}
              className={`flex-shrink-0 position-absolute top-0`}
              style={!isCollapsed ? { left: "80px" } : { left: "22px" }}
              aria-hidden="true"
            /> */}
            <div className="text-bg-danger p-1 flex-grow-1 w-75"></div>
          </div>
          <div className={`d-flex justify-content-center mb-5 mt-5 fw-bolder ${isCollapsed ? "sidebar-header-collapsed" : ""}`}>
            <NavLink className="rounded-1 text-decoration-none text-white" to="/Inicio" title={isCollapsed ? "SSMSO" : ""}>
              {isCollapsed ? (
                <House
                  width={30}
                  height={30}
                  className={`flex-shrink-0 ${isCollapsed ? "" : "me-3"}`}
                  aria-hidden="true"
                />
              ) : (
                <p className="fs-5">SSMSO</p>
              )}
            </NavLink>
          </div>
        </div>

        {/* Navegación (ocupa el espacio disponible) */}
        <div className="flex-grow-1 overflow-auto">
          {navigation.map((item) => (
            <div key={item.name} className="d-flex flex-column">
              <div className="d-flex align-items-center position-relative">
                <NavLink
                  to={item.href!}
                  className={({ isActive }) =>
                    classNames(
                      isActive ? "bg-light text-dark" : "text-white",
                      "d-flex justify-content-start align-items-center py-2 px-3 mb-4 rounded-1 text-decoration-none nav-item flex-grow-1",
                      isCollapsed ? "justify-content-start" : ""
                    )
                  }
                  title={isCollapsed ? item.name : ""}
                >
                  <item.icon
                    width={24}
                    height={24}
                    className={`flex-shrink-0 ${isCollapsed ? "" : "me-3"}`}
                    aria-hidden="true"
                  />
                  {!isCollapsed && <p className="w-100 mb-0">{item.name}</p>}
                </NavLink>
              </div>
            </div>
          ))}
        </div>

        {/* Footer: Configuración + Contraer, siempre al final */}

        {/* Configuración */}
        <div className="nav-item">
          <button
            onClick={() => setMostrarModal(true)}
            className="btn text-light text-decoration-none border-0  d-sm-flex justify-content-start align-items-center w-100"
            title={isCollapsed ? "Configuración" : ""}
          >
            {isCollapsed ? (
              <div className="d-flex align-items-center">
                <Gear width={24} height={24} />
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <Gear width={24} height={24} className="me-3" />
                <p className="mb-0">Configuración</p>
              </div>
            )}
          </button>
        </div>
        {/* Contraer / Expandir */}
        <div className="nav-item">
          <button
            type="button"
            className="btn text-light text-decoration-none borde-0  d-sm-flex justify-content-start w-100"
            onClick={onToggleCollapse}
            aria-label="Toggle sidebar"
            title={isCollapsed ? "Expandir menú" : ""}
          >
            {isCollapsed ? (
              <LayoutSidebarInset width={24} height={24} />
            ) : (
              <>
                <div className="d-flex align-items-center">
                  <LayoutSidebar width={24} height={24} className="me-3" />
                  <p className="mb-0">Contraer</p>
                </div>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Modal de Preferencias */}
      <Preferencias
        isDarkMode={isDarkMode}
        activo={activo}
        mostrarModal={mostrarModal}
        setMostrarModal={setMostrarModal}
      />
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  objeto: state.validaApiLoginReducers,
})

export default connect(mapStateToProps, {})(Sidebar)